import Helmet from "react-helmet";
import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home/Home.page";
import logoImg from "./assets/images/logo-img.png";
import Error from "./pages/Error/Error.page";
import loadingGif from "./assets/images/loading.gif";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoading = () => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  };

  useEffect(() => {
    window.addEventListener("load", handleLoading);

    return () => {
      window.removeEventListener("load", handleLoading);
    };
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <link rel="shortcut icon" href={logoImg} type="image/x-icon" />
        <title>tunifi | music that moves you</title>
      </Helmet>
      {isLoading ? (
        <div className="loading-cmp">
          <img src={loadingGif} alt="loading..." />
        </div>
      ) : (
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Error />} />
        </Routes>
      )}
    </>
  );
}

export default App;
